import HeaderNoAuth from "../Navigation/HeaderNoAuth";
import Footer from "../Navigation/Footer";
import css from "../../css/common.module.css";
import { useLocation } from 'react-router-dom';

function ErrorPage() {
	const location = useLocation();
  	return (
	    <div className="container-fluid">
	      <HeaderNoAuth />
	      {(location.state.errorMessage )? (
            <div id="inerrorMessage" className={css.errorblock}>
              {location.state.errorMessage}
            </div>
          ):(<></>)}
          <div className="d-grid gap-2 mt-2">
	          <label className="form-label">
	          	{t("page.changePasswd.goBackTo")}
	            &nbsp;
	            <Link className="link-primary" to="/">
	            {t("page.login")}
	            </Link>
	          </label>
	      </div>
	      <div className="footer_container">
	      <Footer />
	      </div>
	    </div>
  );
}
export default ErrorPage;
